module.exports = __webpack_public_path__ + "static/media/langusta.05a2edb6.svg";